import { locale } from 'services/locale/es-es';
import { languages } from 'services/locale';

export const initialState = { locale, lang: languages.ES };
